import { css } from 'lit';
export const dropdownStyles = css `
  .select-dropdown {
    width: fit-content;
  }

  .select-dropdown select {
    height: 40px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    background-color: var(--surface-color-default);
    border: 1px solid var(--border-color-default);
    box-sizing: border-box;
    border-radius: 4px;
    color: var(--type-color-default);
    padding: var(--spacing-xs) var(--spacing-s) var(--spacing-xs) var(--spacing-s);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .select-dropdown svg,
  .select-dropdown .icon {
    --goto-icon-size: 20px;
    color: var(--icon-color-brand-default);
    fill: var(--icon-color-brand-default);
    width: 20px;
    height: 20px;
    margin-left: -30px;
    pointer-events: none;
    vertical-align: sub;
  }

  .select-dropdown select:hover {
    border: 1px solid var(--border-color-brand);
  }

  .select-dropdown select:focus {
    border: 2px solid var(--border-color-brand);
    outline: none;
  }

  .select-dropdown option[value='0'] {
    display: none;
  }

  .select-dropdown option {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: var(--synapse-color-neutral-8);
    padding: var(--spacing-s);
    height: 32px;
    background-color: var(--synapse-color-neutral-1);
  }

  .select-dropdown[disabled] select {
    background: var(--surface-color-secondary);
    border: 1px solid var(--surface-color-secondary);
    color: var(--type-color-disabled);
    cursor: not-allowed;
  }

  .select-dropdown[disabled] select:hover {
    border: 1px solid var(--surface-color-secondary);
  }

  .select-dropdown[disabled] svg,
  .select-dropdown[disabled] .icon {
    color: var(--icon-color-disabled);
    fill: var(--icon-color-disabled);
  }
`;
export default dropdownStyles;
